import { useState } from "react";
import { CalendarIcon, X } from "lucide-react";
import { format, parseISO } from "date-fns";
import { it } from "date-fns/locale";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Calendar } from "@/components/ui/calendar";

export const DatePicker = ({ value, onChange, placeholder, testId, min, max }) => {
  const [open, setOpen] = useState(false);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button data-testid={testId} className="flex h-9 w-full items-center gap-2 rounded-md border border-input bg-white px-3 text-left text-sm shadow-sm">
          <CalendarIcon className="h-4 w-4 text-slate-400" />
          <span className={`flex-1 truncate ${value ? "text-slate-800" : "text-slate-400"}`}>
            {value ? format(parseISO(value), "dd/MM/yyyy") : placeholder}
          </span>
          {value && <X className="h-3.5 w-3.5 text-slate-400 hover:text-slate-700" onClick={(e) => { e.stopPropagation(); onChange(""); }} />}
        </button>
      </PopoverTrigger>
      <PopoverContent className="w-auto bg-white p-0" align="start">
        <Calendar mode="single" locale={it} weekStartsOn={1} selected={value ? parseISO(value) : undefined} defaultMonth={value ? parseISO(value) : undefined}
          disabled={[...(min ? [{ before: parseISO(min) }] : []), ...(max ? [{ after: parseISO(max) }] : [])]}
          onSelect={(d) => { onChange(d ? format(d, "yyyy-MM-dd") : ""); setOpen(false); }} initialFocus />
      </PopoverContent>
    </Popover>
  );
};
